import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getConfigParameterAll from '../../services/configParameter/getConfigParameterAll'

export function * fetchConfigParameterAll () {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const configParameterAllCombo = yield call(getConfigParameterAll, auth.token)
    yield put(fetchCombosSuccess({ configParameterAllCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }

    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchConfigParameterAll () {
  yield takeLatest(combosActionTypes.FETCH_ORGANIZED_UNITS_ALL, fetchConfigParameterAll)
}
